<script lang="ts">
	import "../assets/css/ckeditor.css";
	import { transformCkEditorContent } from "../../../core/utils/transformCkEditorContent.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	export let content: string;
	let customClass = "";
	export { customClass as class };

	const { STORAGE_URL } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="contents {customClass}">
	{@html transformCkEditorContent(STORAGE_URL, content)}
</div>
